<zwi-simple-form-page>
  <div class="z-wrapper">
    <div class="zwi-wrapper-content--sm">
      <div class="zwi-page-sections">
        @if (isNativePlatform === false) {
          <zwi-headline>Create a Zwiloo account</zwi-headline>
        } @else {
          <zwi-back-headline (navigateBack)="navigateToIndex()">Create a Zwiloo account</zwi-back-headline>
        }
        <zwi-signup-form (updateAccount)="submit($event)">
          <button mat-flat-button color="primary">Sign up</button>
        </zwi-signup-form>
        <div>
          <zwi-widget>
            <zwi-agreement-message></zwi-agreement-message>
          </zwi-widget>
          <zwi-widget>
            Already have an account? <a href="/index">Sign in now</a>
          </zwi-widget>
        </div>
        @if (isMobile()) {
          <div class="zwi-column-center">
            <zwi-title>Are you a ministry? <a
            class="bold" [routerLink]="['/ministry-sign-up']" target="_self">Sign up here</a>
          </zwi-title>
        </div>
      }

    </div>
    @if (isMobile() === false) {
      <div class="zwi-upper-right">
        <zwi-title>Are you a ministry? <a
        class="bold" [routerLink]="['/ministry-sign-up']" target="_self">Sign up here</a>
      </zwi-title>
    </div>
  }
</div>
</div>
</zwi-simple-form-page>
